export default {
  SET_CURRENT_OPEN_MENU: 'SET_CURRENT_OPEN_MENU',
  SET_CURRENT_MENU: 'SET_CURRENT_MENU',
  TOGGLE_SIDE_NAV: 'TOGGLE_SIDE_NAV',
  CURRENT_PROJECT_ID: 'CURRENT_PROJECT_ID',
  USER_INFO: 'USER_INFO',
  AUTH_URL_LIST: 'AUTH_URL_LIST',
  LANG: 'LANG',
  DICTIONARY: 'DICTIONARY',
  DATA_CART_LIST_PUSH: 'DATA_CART_LIST_PUSH',
  DATA_CART_LIST_REPLACE: 'DATA_CART_LIST_REPLACE',
  DATA_CART_LIST_DEL_ONE: 'DATA_CART_LIST_DEL_ONE',
  X_AREA: 'X_AREA',
  CLOUD_VALUE: 'CLOUD_VALUE',
};



// WEBPACK FOOTER //
// ./src/store/mutation-types.js